module.exports = __webpack_public_path__ + "b5ec98707a02e80ec26be46340abc6ce.svg";